module.exports = __webpack_public_path__ + "img/business-intelligence-big-data.a8b39b17.jpg";